import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetMessageSchema } from '../schemas/fleet-message.schema';

/**
 * Assigns Vehicle Groups to a Map Set
 * @param id The ID of the Map Set the Vehicle Groups are to be added to
 * @param vehicleGroupIds The Vehicle Groups being added
 * @returns Data object indicating success
 */
export function putMapSetsVehicleGroupAssignments(
  this: unknown,
  id: number,
  vehicleGroupIds: number[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        fleetEnvironment.resolve(this).mapSetsVehicleGroupsAssignmentUrl(id),
        {
          method: 'PUT',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
          body: JSON.stringify(vehicleGroupIds),
        }
      )
    )
  ).pipe(
    selectData(
      fleetMessageSchema.extend({
        data: z.array(z.number()),
      })
    )
  );
}
